/**
 * API Configuration
 * 
 * IMPORTANT: Change this configuration based on your environment:
 * 
 * FOR LOCAL DEVELOPMENT (this computer only):
 * - Set API_BASE_URL to: 'http://localhost:8000/api'
 * 
 * FOR LAN TESTING (access from other devices on your network):
 * - Set API_BASE_URL to: 'http://YOUR_LOCAL_IP:8000/api'
 * - Example: 'http://192.168.1.100:8000/api'
 * - Use the batch script to find your IP: get-lan-ip.bat
 * 
 * FOR VPS/PRODUCTION DEPLOYMENT:
 * - Set API_BASE_URL to: 'https://ovacs.com/backend/api'
 *   (or your actual production domain)
 */

const apiConfig = {
  // ========================================
  // 🔧 CHANGE THIS BASED ON YOUR ENVIRONMENT
  // ========================================
  
  // Local Development (default - this computer only)
  // API_BASE_URL: 'http://localhost:8000/api',
  
  // LAN Testing (uncomment and add your local IP - for testing on other devices)
  // API_BASE_URL: 'http://192.168.148.99:8000/api',  // ← Replace XXX with your local IP
  
  // Production (uncomment when deploying to VPS)
  API_BASE_URL: 'https://ovacs.com/backend/api',
  
  // ========================================
  
  // Other configuration options
  TIMEOUT: 60000, // 30 seconds
  MAX_FILE_SIZE: 25 * 1024 * 1024, // 25MB
}

export default apiConfig
